import {
    IconButton,
    IconButtonSize,
    IconButtonTheme,
    Table,
    TableBorderRadius,
    TableBorderStyle,
    TableColumn,
    TableHeaderTheme,
    TableRow,
    TableRowTheme,
} from '@apply/components';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

interface PickedFilesTableProps {
    files: File[];
    onRemove: (file: File) => void;
}

/** The files picked so far: name, size and a button to remove each one; nothing when none are picked. */
export const PickedFilesTable = ({ files, onRemove }: PickedFilesTableProps) => {
    // e.g. 12.3 KB or 4.5 MB
    const formatSize = (bytes: number) =>
        bytes < 1024 * 1024 ? `${(bytes / 1024).toFixed(1)} KB` : `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

    if (files.length === 0) {
        return null;
    }

    const rows: TableRow[] = files.map((file, index) => ({
        name: file.name,
        size: formatSize(file.size),
        remove: (
            <IconButton
                id={`fileDropZone_remove_${index}`}
                theme={IconButtonTheme.TransparentRed}
                size={IconButtonSize.ExtraSmall}
                icon={faTrashCan}
                hint='Remove'
                handleClick={() => onRemove(file)}
            />
        ),
    }));

    return (
        <Table
            data={rows}
            headerTheme={TableHeaderTheme.Gray}
            rowTheme={TableRowTheme.White}
            borderStyle={TableBorderStyle.Solid}
            borderRadius={TableBorderRadius.Small}
            width='100%'
        >
            <TableColumn
                columnKey='name'
                header='File'
                width='65%'
                abbreviateLongText={true}
            />
            <TableColumn
                columnKey='size'
                header='Size'
                width='25%'
            />
            <TableColumn
                columnKey='remove'
                width='10%'
                actionColumn={true}
                center={true}
            />
        </Table>
    );
};
